import Customer from '../../Components/Customer/Customer'
import ZohoId from '../../Components/ZohoId/ZohoId'
import GryvChecklist from '../../Components/GryvChecklist/GryvChecklist'
import useClient from './useClient'
import SDButton from '@/shared/components/SDComponentsNewDesign/SDButton/SDButton'

const Client = () => {
  const { saveCustomer, isSaving, t } = useClient()

  return (
    <div style={{ width: '100%' }}>
      <ZohoId />
      <GryvChecklist />
      <Customer />
      <div>
        <SDButton style={{ width: '100%' }} disabled={isSaving} isLoading={isSaving} onClick={saveCustomer}>
          {t('common:save')}
        </SDButton>
      </div>
    </div>
  )
}

export default Client
